import ComponentHeader from '../main/ComponentHeader';
import {Box, Input, InputGroup, InputLeftElement, useToast, Text, Table,Thead,Tbody,Tr,Th,Td,TableContainer, Spacer} from '@chakra-ui/react'
import { SearchIcon } from '@chakra-ui/icons';
import GruntComponents from '../components';
import { useState, useEffect } from 'react';
import GruntPager from '../custom/GruntPager';
import { getPasmine } from "../../util/apiPasmina";

//import KlaonicaControl from './KlaonicaControl';


const Pasmine = ({onClosePress}) => {
    const [state, setState] = useState({pasmine:[]});
    const [prikaz, setPrikaz] = useState({orderbycol:"id",orderby:"asc",pasmineprikaz:[],rowsperpage:20,currpage:1});
    const toast=useToast();
    

    useEffect(() => {
        const fetchPasmine=async()=>{
            try {
                
                let res=await getPasmine();
                if (res.status===200) {
                    setState({...state,pasmine:res.res});        
                    setPrikaz({...prikaz,pasmineprikaz:res.res}); 
                } else {
                    throw new Error(res.message);
                }
                
            } catch (error) {
                toast({
                    title:"Greška kod dohvata podataka.",
                    status:"error",
                    description:error.message,
                    isClosable:true,
                    duration:2000,
                    position:"top-right",
                });
            }
            
        }
        fetchPasmine();
        
    }, []);

    useEffect(() => {
        const Sort=()=>{
            const asc=prikaz.orderby==="asc";
            let _b;
            let _os=state.pasmine.sort((a,b)=>{
                if (prikaz.orderbycol==="sifra") {
                  _b=a.sifra>b.sifra;
                } else if (prikaz.orderbycol==="naziv") {
                    _b=a.naziv>b.naziv;
                } 

                return asc?(_b?1:-1):(_b?-1:1);
            });
            setPrikaz({...prikaz,pasmineprikaz:_os}); 
        }
        Sort();
    }, [prikaz.orderby]);


    

    
    const getOrderImage=(propname)=>{
        let _res=" ⋮";
        if (propname.toLowerCase()===prikaz.orderbycol){
            _res=" ▴"
            if (prikaz.orderby==="desc") {
                _res=" ▾"
            }
        } 
        return _res;
    }
    const ShowGruntPager=()=>{
        if (prikaz.pasmineprikaz.length>0) {
            return (
                 <GruntPager currpage={prikaz.currpage} rowcount={prikaz.pasmineprikaz.length} rowsperpage={prikaz.rowsperpage} onClick={(pagenum)=>setPrikaz({...prikaz,currpage:pagenum})}/>
                 );    
                
        }
        else {
            return (<></>)
        }
        
    }
    
    const FilterData=(filter)=>{
        const _val=filter.target.value.toLowerCase();
        let _o=state.pasmine.filter((pasm)=>{
            return (pasm.sifra.toLowerCase().includes(_val) ||  pasm.naziv.toLowerCase().includes(_val) );
        });
        setPrikaz({...prikaz,pasmineprikaz:_o,currpage:1}); 
    }

    

    const showBrZapis=()=>{
        return (
          <Text fontSize={'xs'}>Prikazano zapisa: {state.pasmine.length}</Text>
        )
      }
    const getFooter=()=>{
        return (
            
            <Box flexDir={'row'} display={'flex'} w="100%" marginTop={'1.5rem'}>
                
                <Box w="25%">
                    {showBrZapis()}
                </Box>
                <Box w="50%" textAlign={'left'}>
                    {ShowGruntPager()}
                </Box>
                <Box w="25%">
                    
                </Box>
            </Box>
            
        )
    }
const getBodyData=()=>{
    const ar=prikaz.pasmineprikaz.slice((prikaz.currpage-1)*prikaz.rowsperpage,(prikaz.currpage)*prikaz.rowsperpage);
    ar.map((item,i)=>{
        return (
            <Tr  color={'grunt2'} key={item.id}  bg={'white'} fontWeight={'normal'} 
            _hover={{bg:'gray.100',cursor:'pointer'}} h='2rem'>
                <Td textAlign={'center'}>{item.sifra}</Td>
                <Td textAlign={'center'}>{item.naziv}</Td>
            </Tr>
         )
    })
}

    return (
        <Box h={'100%'} display={'flex'} flexDir={'column'} borderColor={'silver'} borderBottomRightRadius={'md'} borderWidth={'0.5px'} key='drzave_component' pl={'0.5rem'} pr={'0.5rem'} pb={'0.2rem'}>
            <ComponentHeader onClosePress={onClosePress} component={GruntComponents.Pasmine}/>
            <Box  display={'flex'} alignItems={'center'}>
                    <InputGroup size={'xs'} w='20rem'>
                        <InputLeftElement pointerEvents={'none'} children={<SearchIcon/>}/>
                        <Input focusBorderColor='grunt2.400' placeholder='Filter' maxLength={'20'} onChange={FilterData}/>
                    </InputGroup>
                  
                    
                    
            
                </Box>
                <Box display={'flex'} flexDir={'column'} flex={1}>
                <TableContainer overflowY={'auto'} h={'74vh'} mt={'0.5rem'}>
                    <Table variant={'unstyled'} size='sm'>
                        <Thead _hover={{cursor:'pointer'}}>
                            <Tr>
                                <Th w={'10%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'} onClick={()=>setPrikaz({...prikaz,orderbycol:"sifra",orderby:prikaz.orderby==="asc"?"desc":"asc"})}>Šifra{getOrderImage("sifra")}</Th>
                                <Th w={'70%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'} onClick={()=>setPrikaz({...prikaz,orderbycol:"naziv",orderby:prikaz.orderby==="asc"?"desc":"asc"})}>Naziv{getOrderImage("naziv")}</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                        {prikaz.pasmineprikaz.slice((prikaz.currpage-1)*prikaz.rowsperpage,(prikaz.currpage)*prikaz.rowsperpage).map((item,i)=>{
                             return (
                                <Tr  color={'grunt2'} key={`row${i}`}  bg={'white'} fontWeight={'normal'} 
                                _hover={{bg:'gray.100',cursor:'pointer'}} h='2rem'>
                                    <Td textAlign={'center'}>{item.sifra}</Td>
                                    <Td textAlign={'center'}>{item.naziv}</Td>
                                </Tr>
                             )
                        })}
                        </Tbody>
                        </Table>
                </TableContainer>
                </Box>
                <Spacer/>
                {getFooter()}
            </Box>
    );
}

export default Pasmine;
/*
{prikaz.pasmineprikaz.slice((prikaz.currpage-1)*prikaz.rowsperpage,(prikaz.currpage)*prikaz.rowsperpage).map((item,i)=>{
                             return (
                                <Tr  color={'grunt2'} key={item.id}  bg={'white'} fontWeight={'normal'} 
                                _hover={{bg:'gray.100',cursor:'pointer'}} h='2rem'>
                                    <Td textAlign={'center'}>{item.sifra}</Td>
                                    <Td textAlign={'center'}>{item.naziv}</Td>
                                </Tr>
                             )
                        })}
*/